import { motion } from "framer-motion";

const BrandSignoff = () => (
  <motion.section
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
    className="border-t border-cloud"
    data-testid="brand-signoff"
  >
    <img
      src="/assets/brand-banner.jpg"
      alt="PLAN FIRST — Understand before you commit. Residential planning, property development, due diligence."
      loading="lazy"
      className="w-full h-auto block"
    />
  </motion.section>
);

export default BrandSignoff;
